import React, { useState } from 'react';
import styles from './index.module.less';
import { Button, message } from 'antd';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import OurModal from '@/components/Modal';

interface Props {
  setIsShowTermsOfUseModel: (isShowTermsOfUseModel: boolean) => void;
  onAgree?: () => void;
}

const Index: React.FC<Props> = ({ setIsShowTermsOfUseModel, onAgree }) => {
  const { t } = useTranslation('common');
  const [checked, setChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleCancel = () => {
    setIsShowTermsOfUseModel(false);
  };

  const handleAgree = () => {
    if (!checked) {
      message.warning(t('Please agree to the terms of use before searching.'));
      setShowError(true);
      return;
    }
    onAgree?.();
    setIsShowTermsOfUseModel(false);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    if (e.target.checked) {
      setShowError(false);
    }
  };

  return (
    <OurModal
      isModalOpen={true}
      handleCancel={handleCancel}
      width={724}
      isCenter
      closeIcon={false}
      isNoAddAccount={false}
      title={null}
      closable={false}
    >
      <div className={styles.termsModal}>
        <div className={styles.title}>{t('Terms Of Use')}</div>
        <div className={styles.subtitle}>
          {t("I hereby affirm that I'm 18 years or older and I agree that as a result of this search:")}
        </div>
        <div className={styles.termsBox}>
          <ul className={styles.termsList}>
            <li>
              {t('I have read and accept the')}{' '}
              <Link href="/privacy-policy" target="_blank" className={styles.link}>
                {t('Privacy Policy')}
              </Link>{' '}
              {t('and')}{' '}
              <Link href="/terms-us" target="_blank" className={styles.link}>
                {t('Terms & Conditions')}
              </Link>
            </li>
            <li>{t('I confirm that using facial/image search services is legal in my country/region.')}</li>
            <li>{t('I consent to send photos to Erasa for performing facial search.')}</li>
            <li>{t('I confirm that I will legally use the search results.')}</li>
          </ul>
        </div>
        <div className={styles.footer}>
          <label className={styles.checkRow}>
            <input
              type="checkbox"
              className={`${styles.checkbox} ${showError ? styles.checkboxError : ''}`}
              checked={checked}
              onChange={handleCheckboxChange}
            />
            <span className={styles.checkText}>{t('I understand and agree to the terms')}</span>
          </label>
          <div className={styles.btnGroup}>
            <Button className={styles.cancelBtn} onClick={handleCancel}>
              {t('Cancel')}
            </Button>
            <Button className={styles.agreeBtn} onClick={handleAgree}>
              {t('Agree and Search')}
            </Button>
          </div>
        </div>
      </div>
    </OurModal>
  );
};

export default Index;
